import { getMarketCalendarStatus, inferMarketFromSymbol, isTaiwanSymbol, type Market } from '@invest-copilot/shared';

export type { Market };

/**
 * 市場狀態判斷 + 智慧預設
 * - 台股: 週一-五 09:00-13:30 (Asia/Taipei)
 * - 美股: 週一-五 09:30-16:00 (America/New_York)
 * 交易日 / 盤別判斷一律走 shared 的 market-calendar（含國定假日、美股半天），
 * 不再自行用「週一到五」近似，避免節假日誤判成開盤。
 */

export function isTwOpenNow(): boolean {
  const s = getMarketCalendarStatus('tw');
  return s.isTradingDay && s.session === 'regular';
}

export function isUsOpenNow(): boolean {
  const s = getMarketCalendarStatus('us');
  return s.isTradingDay && s.session === 'regular';
}

/**
 * 初始市場判斷：哪個現在盤中就選哪個；都沒開先用 localStorage 偏好、否則用 TW
 */
export function detectInitialMarket(stored?: Market | null): Market {
  if (isTwOpenNow()) return 'TW';
  if (isUsOpenNow()) return 'US';
  return stored ?? 'TW';
}

/**
 * 預設 timeframe index（對應 TIMEFRAME_PRESETS）
 * - 不論 open / closed 都用 **5 分 K (index=1)** intraday：
 *   - 盤前：Yahoo 會回最近一個交易日的 intraday（昨日的 5min K）
 *   - 開盤：自動帶今日 intraday（react-query 定時 refetch 自動接上）
 * - 使用者想看長期可手動切日線。
 */
export function defaultTimeframeIdx(_market: Market): number {
  return 1;
}

export function isSymbolTw(symbol: string): boolean {
  return isTaiwanSymbol(symbol);
}

export function symbolMarket(symbol: string): Market {
  return inferMarketFromSymbol(symbol);
}
